import React from 'react';
import Select, { SingleValue, StylesConfig } from 'react-select';
import { Qualification } from '../../features/admin/companies/types';

interface QualificationOption {
  value: number;
  label: string;
}

interface Props {
  value: number | null | undefined;
  qualifications: Qualification[];
  onChange: (value: number | null) => void;
  borderColor?: string;
  isDisabled?: boolean;
  placeholder?: string;
}

export const QualificationSelect: React.FC<Props> = ({
  value,
  qualifications,
  onChange,
  borderColor = '#E5E7EB',
  isDisabled = false,
  placeholder = 'Select a qualification...',
}) => {
  const options: QualificationOption[] = qualifications.map((q) => ({ value: q.id, label: q.name }));
  const selected = options.find((o) => o.value === value) || null;

  const handleChange = (option: SingleValue<QualificationOption>) => {
    onChange(option ? option.value : null);
  };

  const styles: StylesConfig<QualificationOption, false> = {
    control: (base, state) => ({
      ...base,
      borderColor: state.isFocused ? '#3B82F6' : borderColor,
      borderRadius: '0.5rem',
      padding: '2px 4px',
      boxShadow: state.isFocused ? '0 0 0 2px rgba(59,130,246,0.3)' : 'none',
      '&:hover': { borderColor: state.isFocused ? '#3B82F6' : borderColor },
    }),
    menu: (base) => ({
      ...base,
      borderRadius: '0.5rem',
      zIndex: 50,
      overflow: 'hidden',
    }),
  };

  return (
    <Select<QualificationOption>
      options={options}
      value={selected}
      onChange={handleChange}
      placeholder={placeholder}
      isClearable
      isSearchable
      isDisabled={isDisabled}
      styles={styles}
    />
  );
};
